export default "__VITE_ASSET__Crap3Hjp__"